export const invoiceNeutralSwatches: string[] = [
  "#FFFFFF",
  "#F8FAFC",
  "#F1F5F9",
  "#E2E8F0",
  "#CBD5E1",
  "#94A3B8",
  "#64748B",
  "#334155",
  "#1E293B",
  "#0F172A",
];

export const invoiceColorSwatches: string[][] = [
  ["#FEF2F2", "#FFF7ED", "#FFFBEB", "#F0FDF4", "#ECFDF5", "#F0FDFA", "#EFF6FF", "#EEF2FF", "#F5F3FF", "#FDF4FF"],
  ["#FECACA", "#FED7AA", "#FDE68A", "#BBF7D0", "#A7F3D0", "#99F6E4", "#BFDBFE", "#C7D2FE", "#DDD6FE", "#F5D0FE"],
  ["#F87171", "#FB923C", "#FBBF24", "#4ADE80", "#34D399", "#2DD4BF", "#60A5FA", "#818CF8", "#A78BFA", "#E879F9"],
  ["#EF4444", "#FB8E00", "#F59E0B", "#22C55E", "#10B981", "#14B8A6", "#3B82F6", "#6366F1", "#8B5CF6", "#D946EF"],
  ["#DC2626", "#EA580C", "#D97706", "#16A34A", "#059669", "#0D9488", "#2563EB", "#4F46E5", "#7C3AED", "#C026D3"],
  ["#991B1B", "#9A3412", "#92400E", "#166534", "#065F46", "#115E59", "#1E40AF", "#3730A3", "#5B21B6", "#86198F"],
];
